import Axios from 'axios';

/**
 * Which of the opt-in outreach activities a tenant has turned on. The five established activities
 * (Phone Call, Text Message, Electronic, Portal, Fax) are always available and are not represented
 * here - only the two that are configurable.
 */
export interface NoteActivitySettings {
    voicemail: boolean;
    attemptedPhoneCall: boolean;
}

export const NOTE_ACTIVITY_SETTINGS_OFF: NoteActivitySettings = {
    voicemail: false,
    attemptedPhoneCall: false,
};

const SETTING_KEYS = [
    'EnableVoicemailNoteActivity',
    'EnableAttemptedPhoneCallNoteActivity',
] as const;

/** Maps the raw name→value configuration response to typed settings. */
export function toNoteActivitySettings(values: Record<string, unknown> | null | undefined): NoteActivitySettings {
    if (!values) return NOTE_ACTIVITY_SETTINGS_OFF;
    return {
        voicemail: isEnabled(values.EnableVoicemailNoteActivity),
        attemptedPhoneCall: isEnabled(values.EnableAttemptedPhoneCallNoteActivity),
    };
}

/**
 * Reads both configuration values in one request. Never throws: a failed read behaves as "off",
 * which leaves the five established activities working rather than blocking the note form.
 */
export async function loadNoteActivitySettings(): Promise<NoteActivitySettings> {
    try {
        const response = await Axios.get<Record<string, unknown>>(`/Configuration/${SETTING_KEYS.join(',')}`);
        return toNoteActivitySettings(response.data);
    } catch (error) {
        console.warn('Failed to load note activity configuration; treating both activities as off.', error);
        return NOTE_ACTIVITY_SETTINGS_OFF;
    }
}

/** The endpoint reads straight off a BIT column, which can arrive as a boolean or as a string. */
function isEnabled(value: unknown): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
}
